import { Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";

import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

export const ShippingList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState<string | number>(0);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const printRef = useRef<HTMLDivElement>(null);

    const dispatch = useDispatch();
    const { showMessage } = useSnackbar();

    const source = {
        url: "Vyapar/CourierShippment/search",
        page: 1,
        pageSize: 10,
        filter: [],
        sort: [],
    };

    useEffect(() => {
        updateMainHeader('Courier Shippment');
    })

    breadCrumbsStore.updateBreadCrumbs([
        { 'Courier Shippment List': '/shipping/list' },
    ]);

    const handleAction = (action: string, row: { customerName: string, id: number }) => {

        if (action === "Edit") {
            navigate(`/shipping/edit/${row.id}`);
        } else if (action === "Delete") {
            setSelectedId(row.id);
            setPopupOpen(true);
        }else if(action === "Print"){
            handlePrint(row);
        }
    };

    const columns: IColumns[] = [
        {
            header: "Courier Name",
            fieldName: "courierName",
            tooltip: true,
        },
        {
            header: "AWB",
            fieldName: "awb",
            tooltip: true,
        },
        {
            header: "Order ID",
            fieldName: "orderId",
            tooltip: true,
        },
        {
            header: "Payment Mode",
            fieldName: "paymentMode",
            tooltip: true,
        },
        {
            header: "Payment Amount",
            fieldName: "paymentAmount",
            tooltip: true,
        },
        {
            header: "Weight",
            fieldName: "weight",
            tooltip: true,
        },
        // {
        //     header: "Barcode",
        //     fieldName: "barcode",
        //     tooltip: true,
        // },
        {
            header: "Created At",
            fieldName: "createdAt",
            tooltip: true,
            type: "date",
        },
        {
            header: "Ship From",
            fieldName: "shipFrom.name",
            tooltip: true,
        },
        {
            header: "Ship To",
            fieldName: "shipTo.name",
            tooltip: true,
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Edit", "Delete", "Print"],
            actionCallback: handleAction,
        },
    ];

    const handleClick = () => {
        navigate("/shipping/create");
    };

    const handlePrint = (data: any) => {

        const printWindow = window.open("", "_blank");

        if (!printWindow) return;

        const printContent = `
<html>
<head>
<title>Shipping Label - ${data.awb}</title>

<style>

@page {
  size: 4in 6in;
  margin: 0;
}

body{
  font-family: Arial, sans-serif;
  width: 4in;
  height: 6in;
  margin:0;
  padding:10px;
  box-sizing:border-box;
}

.label{
  border:2px solid black;
  height:100%;
  display:flex;
  flex-direction:column;
}

.header{
  text-align:center;
  font-weight:bold;
  font-size:18px;
  padding:6px;
  border-bottom:2px solid black;
}

.awb{
  text-align:center;
  font-size:24px;
  font-weight:bold;
  padding:8px;
  border-bottom:2px solid black;
}

.section{
  padding:8px;
  border-bottom:1px solid #000;
  font-size:13px;
}

.section-title{
  font-weight:bold;
  margin-bottom:3px;
}

.address{
  line-height:1.3;
}

.row{
  display:flex;
  justify-content:space-between;
}

.barcode{
  text-align:center;
  padding:10px;
}

.barcode-number{
  font-size:16px;
  font-weight:bold;
  letter-spacing:2px;
}

.footer{
  text-align:center;
  font-size:12px;
  padding:6px;
}

</style>
</head>

<body>

<div class="label">

<div class="header">
${data.courierName}
</div>

<div class="awb">
AWB: ${data.awb}
</div>

<div class="section">
<div class="section-title">Ship To</div>
<div class="address">
<b>${data.shipTo.name}</b><br/>
${data.shipTo.addressLine}<br/>
${data.shipTo.city}, ${data.shipTo.state} - ${data.shipTo.pincode}<br/>
📞 ${data.shipTo.phone}
</div>
</div>

<div class="section">
<div class="section-title">Ship From</div>
<div class="address">
<b>${data.shipFrom.name}</b><br/>
${data.shipFrom.addressLine}<br/>
${data.shipFrom.city}, ${data.shipFrom.state} - ${data.shipFrom.pincode}<br/>
📞 ${data.shipFrom.phone}
</div>
</div>

<div class="section row">
<div>
<b>Order ID</b><br/>
${data.orderId}
</div>

<div>
<b>Weight</b><br/>
${data.weight} kg
</div>
</div>

<div class="section row">
<div>
<b>Payment</b><br/>
${data.paymentMode}
</div>

<div>
<b>Amount</b><br/>
₹${data.paymentAmount}
</div>
</div>

<div class="barcode">
<div style="font-size:40px; letter-spacing:6px;">
|||| ||| |||| || |||
</div>

<div class="barcode-number">
${data.barcode}
</div>
</div>

<div class="footer">
Generated Shipping Label
</div>

</div>

</body>
</html>
`;

        printWindow.document.open();
        printWindow.document.write(printContent);
        printWindow.document.close();

        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        };
    };
    
    return (
        <Grid p={3}>
            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <WSDataGrid
                        id="shippingGrid"
                        title="Shipping Label"
                        columns={columns}
                        source={source}
                        searchBox={{ fieldName: 'name' }}
                        addButton={{ label: "Add Shipping Label", color: "secondary" }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{
                            backgroundColor: "whitesmoke",
                            border: "1px solid whitesmoke",
                        }}
                    />
                </Grid>

                <ConfirmationPopup
                    type="DELETE"
                    apiUrl="Vyapar/CourierShippment"
                    id={selectedId}
                    confirmMessage="Are you sure you want to delete this shipping label?"
                    open={isPopupOpen}
                    onClose={() => setPopupOpen(false)}
                    onConfirm={(data: any) => {
                        dispatch(resetDataComponent("shippingGrid"));
                        if (data.success === true) {
                            showMessage(data?.message, "success");
                        } else {
                            showMessage(data?.message, "error");
                        }
                    }}
                />

            </Grid>

            <div ref={printRef} style={{ display: 'none' }} />
        </Grid>
    );
});
